import React from "react";
import "./chats-dashboard.css";
import profileIcon from "../../assets/images/chats/profile-icon.png";
import { useTheme } from "../../utils/ThemeContext";
import { useHistory } from "react-router-dom";

const ChatComponentDashboard = () => {
  const { theme } = useTheme();
  const history = useHistory();

  const messages = [
    {
      id: 1,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 2,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
    {
      id: 3,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 4,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
    {
      id: 5,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 6,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
    {
      id: 7,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 8,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
    {
      id: 9,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 10,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
    {
      id: 11,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 12,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
    {
      id: 13,
      text: "Hello user, how are you? What's up?",
      fromMe: false,
    },
    {
      id: 14,
      text: "I'm doing well, thank you!",
      fromMe: true,
    },
  ];
  const handleButtonClick = () => {
    history.push("/chats")
  };
  return (
    <div style={{ position: "relative" }} className="hover-container">
      <div
        style={{
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
        className="chat-section-dashboard-container"
      >
        <div className="chat-section-header">
          <h3
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}
          >
            Chats
          </h3>
          <button className="chat-section-button">Account</button>
        </div>
        <div className="chat-conversation-section">
          {messages.map((message) => (
            <div key={message.id} className="chat-message-wrapper">
              <div
                style={{
                  backgroundColor: theme === "dark" ? "#232323" : "white",
                }}
                className="profile-icon-container"
              >
                {!message.fromMe && (
                  <>
                    <img src={profileIcon} alt="profile-icon" />
                    <div className="profile-status-tip"></div>
                  </>
                )}
              </div>
              <div
                className={`chat-message-container ${
                  message.fromMe ? "message-from-me" : "message-from-other"
                }`}
              >
                {message.text}
              </div>
            </div>
          ))}
        </div>

        <div className="chat-footer">
          <input
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
            type="text"
            placeholder="Type a message, hit enter to send..."
          />
          <button>Send</button>
        </div>
      </div>
      <div className="chat-overlay">
        <button className="chat-overlay-button" onClick={handleButtonClick} disabled={localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) === "Financial Advisor Client" ? true :false } >
          Go to Asset Planet Chat
        </button>
      </div>
    </div>
  );
};

export default ChatComponentDashboard;
